import { CustomerAreaMetricCard } from '../customer-area'
import type { ShopMessageKey } from '../../../i18n'

type TranslateFn = (key: ShopMessageKey, params?: Record<string, string | number>) => string

type PrivacyMetricsSectionProps = {
  accountStatusLabel: string
  exportStateLabel: string
  privacyUpdatedAtValue: string
  accountStatusTone: 'success' | 'warning'
  t: TranslateFn
}

export const PrivacyMetricsSection = ({
  accountStatusLabel,
  exportStateLabel,
  privacyUpdatedAtValue,
  accountStatusTone,
  t,
}: PrivacyMetricsSectionProps) => (
  <section className="grid gap-3 sm:grid-cols-3">
    <CustomerAreaMetricCard
      label={t('customer.privacy.overview.accountStatus')}
      value={accountStatusLabel}
      tone={accountStatusTone}
    />
    <CustomerAreaMetricCard label={t('customer.privacy.export.state')} value={exportStateLabel} />
    <CustomerAreaMetricCard
      label={t('customer.privacy.overview.privacyUpdatedAt')}
      value={privacyUpdatedAtValue}
    />
  </section>
)
